/**
 * @file qrCode.graphql.ts
 * queries/mutations for qrCodes.
 */

import { gql } from "@apollo/client";

export const LOAD_QR_CODES_QUERY = gql`
  query LoadQrCodes {
    loadQrCodes {
      qrCodeId
      displayName
      baseUrl
      utmCampaignId
      utmCampaignName
      utmSource
      utmTerm
      createdAt
      removedAt
      fullUrl
    }
  }
`;

export const CREATE_QR_CODE_MUTATION = gql`
  mutation CreateQrCode($input: CreateQrCodeInput!) {
    createQrCode(input: $input) {
      result {
        ... on QRCode {
          qrCodeId
          displayName
          baseUrl
          utmCampaignId
          utmCampaignName
          utmSource
          utmTerm
          createdAt
          removedAt
        }
        ... on CreateQrCodeFailure {
          message
        }
      }
    }
  }
`;

export const DELETE_QR_CODE_MUTATION = gql`
  mutation DeleteQrCode($input: DeleteQrCodeInput!) {
    deleteQrCode(input: $input) {
      result {
        ... on QRCode {
          qrCodeId
          displayName
          baseUrl
          utmCampaignId
          utmCampaignName
          utmSource
          utmTerm
          createdAt
          removedAt
        }
        ... on DeleteQrCodeFailure {
          message
        }
      }
    }
  }
`; 